// TODO: This should use config from somewhere.
export function isProd() {
  const { origin } = window.location;
  return (
    origin === 'https://folio.no' || origin === 'https://starte-as.fiken.no'
  );
}
